"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationServiceProvider = exports.DialogServiceContext = void 0;
var react_1 = __importDefault(require("react"));
var Dialog_1 = __importDefault(require("components/Dialog"));
exports.DialogServiceContext = react_1.default.createContext(Promise.reject);
exports.ConfirmationServiceProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.default.useState(null), confirmationState = _b[0], setConfirmationState = _b[1];
    var _c = react_1.default.useState(false), open = _c[0], setOpen = _c[1];
    var awaitingPromiseRef = react_1.default.useRef();
    var openConfirmation = function (options) {
        setConfirmationState(options);
        setOpen(true);
        return new Promise(function (resolve, reject) {
            awaitingPromiseRef.current = { resolve: resolve, reject: reject };
        });
    };
    var handleClose = function () {
        if (confirmationState.catchOnCancel && awaitingPromiseRef.current) {
            awaitingPromiseRef.current.reject();
        }
        setOpen(false);
        setTimeout(function () {
            handleClosed();
        }, 300);
    };
    var handleSubmit = function () {
        if (awaitingPromiseRef.current) {
            awaitingPromiseRef.current.resolve();
        }
        setOpen(false);
        setTimeout(function () {
            handleClosed();
        }, 300);
    };
    var handleClosed = function () {
        setConfirmationState(null);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.DialogServiceContext.Provider, { value: openConfirmation, children: children }),
        react_1.default.createElement(Dialog_1.default, __assign({ open: Boolean(open), onSubmit: handleSubmit, onClose: handleClose }, confirmationState))));
};
